import { Component,  OnInit, OnDestroy } from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { NgxSpinnerService } from 'ngx-spinner';
import { JoSchedularService } from 'src/app/_services/jo-schedular.service';
import { LanguageTranslateService } from "src/app/_services/language-translate.service";
import { ModalServiceService } from 'src/app/_services/modal-service.service';
import { ErrorUtil } from 'src/app/_utilities/error';
import { SubscriptionUtil } from 'src/app/_utilities/subscription';

@Component({
  selector: 'app-print-job-sheet',
  standalone: false,
  templateUrl: './print-job-sheet.component.html',
  styleUrl: './print-job-sheet.component.scss'
})
export class PrintJobSheetComponent extends SubscriptionUtil implements OnInit, OnDestroy {

  translate: any;
  users: any;
  technicianIds: any[]=[];
  pdfBlobUrl: string | null = null;
  data: any ;

  dataSave:any={
  date: null,
  technicianIds:null,
  fieldLabels:null
 
}
fieldLabels: any[] = [
  { key: 'SKU',           translatePath: 'product.fields.sku.singular'       },
  { key: 'Part Name',     translatePath: 'module.preventiveParts.label.singular'       },
  { key: 'Qty Needed',    translatePath: 'product.fields.name.singular'       },
  { key: 'Spare Parts',   translatePath: 'product.label.singular'        },
  { key: 'jobOrderName',  translatePath: 'jobOrder.fields.name.singular'      },
  { key: 'jobOrderType',  translatePath: 'jobOrder.fields.type.singular'      },
  { key: 'assetName',     translatePath: 'asset.fields.name.singular'         },
  { key: 'serialNumber',  translatePath: 'asset.fields.serialNo.singular'     },
  { key: 'assetsType',    translatePath: 'asset.fields.type.singular'         },
  { key: 'serviceZone',   translatePath: 'setup.serviceZone.label.singular'   },
  { key: 'customer',      translatePath: 'customer.label.singular'       },
  { key: 'fault',         translatePath: 'jobOrder.fields.fault.singular'     },
  { key: 'resolution',    translatePath: 'jobOrder.fields.resolution.singular'},
  { key: 'notes',         translatePath: 'jobOrder.fields.note.singular'     },
];
 // Returns true if technicianIds is empty or not an array
  isTechnicianIdsEmpty(): boolean {
    return !Array.isArray(this.technicianIds) || this.technicianIds.length === 0;
  }
  constructor(
    public modalRef : BsModalRef,
    private languageTranslateService: LanguageTranslateService,
      private errorUtil: ErrorUtil,
      private joSchedularService: JoSchedularService,
      private spinner: NgxSpinnerService,
      private modalService         : ModalServiceService
  ) { 
    super();
  }

  ngOnInit(): void {
    console.log(this.data)
    this.dataSave.date = this.data.selectedDate;



    this.joSchedularService.getTechnicians().subscribe((users:any)=>{
      for(var i=0;i<users.length;i++){
        users[i].name = users[i].firstName + ' ' + users[i].lastName;
      }
      this.users = users;
    })
    this.getLanguageData();
  }
  //Language
  getLanguageData() {
    this.push(this.languageTranslateService.wordSrc$.subscribe(data => { 
      if(Object.keys(data).length != 0){
        this.translate = data
      }
    }))
    console.log("translate",this.translate)
  }

  push(obs:any) {
    super.push(obs);
  }
  ngOnDestroy(): void {
    super.ngOnDestroy();
  }
  buildFieldLabelsPayload(): any {
  const result: any = {};

  this.fieldLabels.forEach((element: any) => {
    if (element.translatePath) {
      element.headerName = this.getNestedValue(this.translate, element.translatePath);
    }

    let finalLabel = element.headerName ?? element.key;

    // ✅ If key starts with 'jobOrderName' — append extra translation
    if (element.key === 'jobOrderName') {
      const extra1 = this.getNestedValue(this.translate, 'jobOrder.label.singular');
      const extra2 = this.getNestedValue(this.translate, 'jobOrder.fields.name.singular');
      finalLabel   = `${extra1} ${extra2}`.trim();
    }
    // ✅ If key starts with 'jobOrderType' — append extra translation
    if (element.key === 'jobOrderType') {
      const extra1 = this.getNestedValue(this.translate, 'jobOrder.label.singular');
      const extra2 = this.getNestedValue(this.translate, 'jobOrder.fields.type.singular');
      finalLabel   = `${extra1} ${extra2}`.trim();
    }

    // ✅ If key is 'Part Name' — append extra translation
    else if (element.key === 'Part Name' ||  element.key === 'Qty Needed' ) {
      const extra1 = this.getNestedValue(this.translate, 'product.label.singular');
      const extra2 = this.getNestedValue(this.translate, 'product.fields.name.singular');
      finalLabel   = element.key; // `${extra1} ${extra2}`.trim(); -- As per discussion, keeping it as 'Part Name' instead of appending product translations
    }
     else if (element.key === 'assetName') {
      const extra1 = this.getNestedValue(this.translate, 'asset.label.singular');
      const extra2 = this.getNestedValue(this.translate, 'asset.fields.name.singular');
      finalLabel   = `${extra1} ${extra2}`.trim();
    }
     else if (element.key === 'assetsType') {
      const extra1 = this.getNestedValue(this.translate, 'asset.label.singular');
      const extra2 = this.getNestedValue(this.translate, 'asset.fields.type.singular');
      finalLabel   = `${extra1} ${extra2}`.trim();
    }

    result[element.key] = finalLabel;
  });

  return result;
}

getNestedValue(obj: any, path: string): string {
  return path.split('.').reduce((acc: any, key: string) => acc?.[key], obj) ?? path;
}



  savePrintData() {
  this.dataSave.technicianIds = this.technicianIds;

    // ✅ Build translated field labels and assign to payload
  this.dataSave.fieldLabels = this.buildFieldLabelsPayload();

   console.log('fieldLabels payload:', this.dataSave.fieldLabels);
   
  this.spinner.show();
  this.joSchedularService.printJobSheet(this.dataSave).subscribe({
    next: (res: any) => {
      this.spinner.hide();

      const blob = res.body as Blob;
      if (!blob || blob.size === 0) {
        this.errorUtil.setErrorMessage(400, null, 'No PDF received', 'error', 3000);
        return;
      }

      // ✅ Revoke previous URL to prevent memory leaks
      if (this.pdfBlobUrl) {
        URL.revokeObjectURL(this.pdfBlobUrl);
      }

      // ✅ Create blob URL and display in iframe
      this.pdfBlobUrl = URL.createObjectURL(blob);
    },
    error: (err) => {
  this.spinner.hide();

  // ✅ Error body is a Blob because responseType is 'blob'
  // Need to read the blob as text to get the actual error message
  if (err.error instanceof Blob) {
    const reader = new FileReader();
    reader.onload = () => {
      try {
        const errorJson = JSON.parse(reader.result as string);
        console.error('API Error details:', errorJson);
        // ✅ Show the actual error message from API
        this.errorUtil.setErrorMessage(
          err.status,
          null,
          errorJson?.message ?? errorJson?.title ?? 'Failed to generate PDF',
          'error',
          5000
        );
      } catch (e) {
        // ✅ If not JSON, show raw text
        console.error('API Error raw:', reader.result);
        this.errorUtil.setErrorMessage(err.status, null, reader.result as string, 'error', 5000);
      }
    };
    reader.readAsText(err.error);
  } else {
    this.errorUtil.setErrorMessage(err.status, null, err, 'error', 3000);
  }
}
  });
}
// ✅ New method to trigger PDF download
downloadPdf(): void {
  if (!this.pdfBlobUrl) return;

  // ✅ Create a temp anchor and trigger download
  const link    = document.createElement('a');
  link.href     = this.pdfBlobUrl;
  // ✅ Use current date in filename
  const dateStr = new Date().toISOString().split('T')[0]; // e.g. 2026-05-08
  link.download = `job-sheet-${dateStr}.pdf`;
  link.click();
}
openEmailModal(): void {
  if (!this.pdfBlobUrl) return;

  const data = {
    fieldLabels  : this.dataSave.fieldLabels,
    date        : this.dataSave.date,
    technicianIds: this.dataSave.technicianIds,
    // ✅ Pass any other data the email modal needs
  };

  this.modalRef.hide(); // ✅ close current modal first if needed
  this.modalService.openModal('sendEmailPdfJo', data);
}

}
